<div class="photo shine"></div>